import { DECLARE_TICKET_RULE_STATUS_MAPPING_VALUES } from '@/constants';

export default {
  ticketUrlAndId: 'Ticket URL and ID',
  ticketUrlAndIdHelpText: 'The ticket URL received from the API response can be added to the alarm dynamic infos.',
  dataFromOneStepAttention: 'Data from the API response can be taken only from one step of a rule.',
  ticketID: 'Ticket ID',
  ticketURL: 'Ticket URL',
  ticketURLTitle: 'Ticket URL title',
  ticketURLTitleHelp: 'This title will display in the body of link tag: <strong>&lt;a href=&quot;{URL}&quot;&gt;{TITLE}&lt;/a&gt;</strong>',
  ticketSystemName: 'Ticket system name',
  allowTicketURLTemplate: 'Allow variables in the URL',
  allowTicketIdTemplate: 'Allow variables in the ID',
  alarmFieldName: 'Alarm field name',
  responseField: 'Response field',
  responseFieldHelpText: 'API Response field in JSON format where the "{field}" is taken from',
  emptyResponse: 'Empty response',
  isRegexp: 'The value can be a RegExp',
  addWebhook: 'Add webhook',
  emptyFields: 'No fields added yet',
  emptyWebhooks: 'No webhooks added yet',
  workflowIfStepFails: 'If this step fails',
  continueWithNextStep: 'Continue with next steps',
  webhookTicketDeclarationExist: 'Webhook ticket declaration already exist in another step',
  headerFieldFromPreviousSteps: 'Header field from previous steps',
  responseFieldFromStep: 'Response field from the step #N',
  responseFieldFromPreviousSteps: 'Response field from previous steps',
  userId: 'User ID',
  actionInitiator: 'Action initiator',
  triggerEventMessage: 'Trigger event message',
  noRulesForAlarms: 'No rules to apply for the selected alarms',
  oneTicketForAlarms: 'One ticket for all alarms',
  applyRules: 'Apply rules',
  noAckItems: 'There is {count} item without ack. Ack event for the item will send before. | There is {count} items without ack. Ack events for items will send before.',
  ruleName: 'Rule name',
  checkSyntax: 'Check syntax',
  syntaxIsValid: 'Syntax is valid',
  ticketResources: 'Declare ticket for resources',
  massRemove: 'Remove declare ticket rules',
  massEnable: 'Enable declare ticket rules',
  massDisable: 'Disable declare ticket rules',
  checkTicketStatus: 'Check ticket status',
  checkTicketStatusHelpText: 'Enable to verify that the ticket exists in the ticket system before performing the next steps.',
  ticketStatusMapping: 'Ticket status mapping',
  ticketStatusMappingHelpText: 'At least one source value must be mapped to Canopsis "Closed" value.',
  ticketStatusMappingUnmappedToOpen: 'All unmapped source values will be mapped to Canopsis status "Unknown".',
  sourceValue: 'Source value',
  canopsisValue: 'Canopsis value',
  addMappingPair: 'Add mapping pair',
  ticketStatusSourceField: 'Ticket status source field',
  allowTicketStatusSourceTemplate: 'Allow variables in the Ticket status source field',
  reuseHeadersAndAuthFromTicketDeclarationRule: 'Reuse headers and auth from ticket declaration rule',
  status: {
    [DECLARE_TICKET_RULE_STATUS_MAPPING_VALUES.unknown]: 'Unknown',
    [DECLARE_TICKET_RULE_STATUS_MAPPING_VALUES.open]: 'Open',
    [DECLARE_TICKET_RULE_STATUS_MAPPING_VALUES.assigned]: 'Assigned',
    [DECLARE_TICKET_RULE_STATUS_MAPPING_VALUES.inProgress]: 'In progress',
    [DECLARE_TICKET_RULE_STATUS_MAPPING_VALUES.closed]: 'Closed',
  },
  errors: {
    webhookRequired: 'The webhooks must be added',
    webhookTicketDeclarationRequired: 'Some one webhook ticket declaration must be set',
    ticketRequired: 'Some one ticket must be add',
    statusMappingRequired: 'At least one mapping pair must be added',
  },
};
